module.exports = __webpack_public_path__ + "img/bg_shicai.d8d042e3.png";